import React from 'react';
import PropTypes from 'prop-types';

import { H2, H3, P } from '@decisiv/ui-components';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import Link from '@decisiv/ui-components/lib/components/Link';
import WarningMessage from 'components/WarningMessage';
import styled from 'styled-components';
import ToggleablePreferenceRow from './ToggleablePreferenceRow';

const InvitationMessageBody = ({ userId, translations }) => (
  <>
    {translations.invitation_prefix}
    <Link
      to={`/users/edit/${userId}#notifications`}
      text={translations.invitation_link}
      iconPosition="right"
    />
    {translations.invitation_suffix}
  </>
);
InvitationMessageBody.propTypes = {
  userId: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    invitation_prefix: PropTypes.string,
    invitation_link: PropTypes.string,
    invitation_suffix: PropTypes.string,
  }).isRequired,
};

const StyledAlert = styled.div`
  margin-bottom: 20px;

  p {
    margin-top: 0;
  }
`;

function Estimate({
  model,
  kinds,
  user,
  smsCommunicationDisabled,
  translations,
}) {
  return (
    <div style={{ margin: 'auto -20px' }}>
      <Flex flexDirection="column" style={{ maxWidth: '390px' }}>
        {smsCommunicationDisabled && (
          <StyledAlert>
            <WarningMessage
              intent="warning"
              title={translations.sms_communication_disabled}
            />
          </StyledAlert>
        )}
        {!smsCommunicationDisabled && (
          <StyledAlert>
            <WarningMessage
              intent="info"
              title={translations.sms_opt_out_info}
            />
          </StyledAlert>
        )}
        <H2 style={{ padding: '0px 20px' }}>{translations.heading}</H2>
        <H3 style={{ marginTop: '25px', padding: '0px 20px' }}>
          {translations.subheading}
        </H3>
        <P
          style={{
            fontSize: '12px',
            color: '#737482',
            marginTop: '5px',
            padding: '0px 20px',
          }}
        >
          {translations.description}
        </P>

        {kinds.map((kind, index) => (
          <div
            key={kind.name}
            style={index % 2 !== 0 ? { backgroundColor: '#F1F2F880' } : {}}
          >
            <div style={{ margin: '15px 20px' }}>
              <ToggleablePreferenceRow
                kind={kind}
                user={user}
                model={model}
                smsCommunicationDisabled={smsCommunicationDisabled}
                key={`preference-row-${kind.name}`}
              />
            </div>
          </div>
        ))}

        <div style={{ margin: '0px 20px' }}>
          <WarningMessage
            intent="info"
            title={translations.invitation_title}
            subtitle={
              <InvitationMessageBody
                userId={user.id}
                translations={translations}
              />
            }
          />
        </div>
      </Flex>
    </div>
  );
}

Estimate.propTypes = {
  model: PropTypes.string.isRequired,
  kinds: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      channels: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          title: PropTypes.string,
          value: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
    csrfToken: PropTypes.string,
  }).isRequired,
  smsCommunicationDisabled: PropTypes.bool.isRequired,
  translations: PropTypes.shape({
    sms_communication_disabled: PropTypes.string,
    sms_opt_out_info: PropTypes.string,
    heading: PropTypes.string,
    subheading: PropTypes.string,
    description: PropTypes.string,
    invitation_title: PropTypes.string,
    invitation_prefix: PropTypes.string,
    invitation_link: PropTypes.string,
    invitation_suffix: PropTypes.string,
  }).isRequired,
};

export default Estimate;
